import React from 'react'
import { Link } from 'react-router-dom'
import MessageUtils from '../../util/MessageUtils'
import SpinnerUI from '../output/SpinnerUI'

// Link with spinner to indicate busy
// The Link handles onClick event, does not navigate to another location
const LinkWithSpinnerUI = ({ label, messageList, labelKey, args, className, onClick, dataAccId, rowId, busy, spinnerOnLeft,
  errorList, successMsg
}) =>
  <span className={`g_flex_h ${spinnerOnLeft ? 'g_flex_right' : 'g_flex_left'} ${className ? className : ''}`}>
    {
      successMsg &&
      <span className='g_success'>{successMsg}</span>
    }
    {
      errorList && errorList.length > 0 &&
      <div className='g_error'>
        {errorList.map((error, index) => (
          <div key={index}>{error}</div>
        ))}
      </div>
    }
    {
      spinnerOnLeft &&
      <SpinnerUI className='g_m_right_50' reserveSpace={true} show={busy} />
    }
    <Link to='#' onClick={onClick} data-row-id={rowId} data-acc-id={dataAccId}>
      {
        label &&
        <React.Fragment>{label}</React.Fragment>
      }
      {
        !label &&
        <React.Fragment>
          {MessageUtils.getMessageValue(messageList, labelKey, args)}
        </React.Fragment>
      }
    </Link>
    {
      !spinnerOnLeft &&
      <SpinnerUI className='g_m_left_50' reserveSpace={true} show={busy} />
    }
  </span>

export default LinkWithSpinnerUI
